package one.healthium.update_food_preferences.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPreferencesCategoryOptionsDto(
    @SerialName("id") val id: String,
    @SerialName("options") val options: List<FoodPreferenceOptionDto>,
)